var initialized = false;
var min_slide = 4;
var max_slide = 7;
var current_slide = min_slide;
var current_color = false;

$(function() {
  
  $('.customizer-slides,.customizer-instructions').swipe({
    swipeRight: slideRight,
    swipeLeft: slideLeft,
    threshold: 10
  });
  $('.customizer-color').on('click',function() {
    $('.customizer-color').toggleClass('active');
    $('.customizer-options').slideToggle();
  });
  $(document).click(function(e) {
    var target = e.target; //target div recorded
    if($('.customizer-color').hasClass('active') && !$(target).closest(".customizer-color").length) $('.customizer-color').click();
  });
  selectColor($('.customizer-options').children().first(),'cobre');
  initialized = true;

  $('.slider-caracteristicas,.slider-proyectos').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
    nextArrow: '<button type="button" class="slick-next">&gt;</button>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });
  
  /* Proyectos */
  projectsSlider();

  $(window).resize( function () {
    projectsSlider();
  });
});

function slideLeft() {
  if(current_slide < max_slide) {
    current_slide++;
    updateSlide();
  }
}

function slideRight() {
  if(current_slide > min_slide) {
    current_slide--;
    updateSlide();
  }
}

function selectColor(element,color) {
  current_color = color;
  updateSlide();

  $('.customizer-color > img').attr('src',$(element).find('img').attr('src'));
  $('.customizer-options .color').removeClass('active');
  $(element).addClass('active');
}

function updateSlide() {
  if(initialized && $('.customizer-instructions').length) $('.customizer-instructions').remove();
  $('.customizer-hoops').text(current_slide+' luces');
  $('.customizer-slides .item').hide();
  $('.customizer-slides .item.hoop-'+current_slide+'.'+current_color).show();

  // Flechas desktop
  $('.customizer-arrow').css('visibility','visible');
  $('.customizer-arrow-left').text((current_slide - 1) + ' luces');
  $('.customizer-arrow-right').text((current_slide + 1) + ' luces');
  if(current_slide == min_slide) $('.customizer-arrow-left').css('visibility','hidden');
  if(current_slide == max_slide) $('.customizer-arrow-right').css('visibility','hidden');
}

/* Proyectos*/
function projectsSlider () {

  	var $projectsSlider = $('.projects-list .slider-for-small');

    if ( $('.projects-list').length && $('#is-small').is(':visible') ) {

      $projectsSlider.slick({
        adaptiveHeight: true,
        infinite: false
      });

      $projectsSlider.on('afterChange', function(e, a, b){

        if ( b + 1 === a.slideCount ) {
          $(e.currentTarget).closest('.projects-list').find('.btn-more').trigger('click');
        }

      });

    }

    if ( !$('#is-small').is(':visible') && $projectsSlider.length && $projectsSlider.hasClass('slick-initialized') ) {

      $projectsSlider.slick('unslick');

    }

}